import React, { useCallback } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import LoadTable from "../../app/generic/loadTable";
import IconButton from "../../app/generic/iconButton";
import { deleteEntity } from "../../../modules/crudOperations";
import TableRowActions from "../../app/generic/tableRowActions";

function AddressListTable({
  push,
  addresses,
  loadAddresses,
  selectedAddresses,
  setSelectedAddresses,
}) {
  const intl = useIntl();
  const dropAddress = useCallback(
    (addressId) => {
      deleteEntity(
        "address",
        addressId,
        intl.formatMessage({ id: "customer", defaultMessage: "Zákazník" }),
        intl.formatMessage({
          id: "customer.errorName",
          defaultMessage: "zákazníka",
        }),
        loadAddresses
      );
    },
    [intl, loadAddresses]
  );

  const handleNewAddress = useCallback(
    (address) => {
      push(`/customer/${address.key}/add`);
    },
    [push]
  );

  const handleEditAddress = useCallback(
    (address) => {
      push(`/customer/${address.key}/edit`);
    },
    [push]
  );

  const columns = [
    {
      key: "name",
      title: intl.formatMessage({
        id: "address.name",
        defaultMessage: "Název",
      }),
      dataIndex: "name",
      sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : -1),
    },
    {
      key: "street",
      title: intl.formatMessage({
        id: "address.street",
        defaultMessage: "Ulice",
      }),
      dataIndex: "street",
      sorter: (a, b) => (a.street ? a.street.localeCompare(b.street) : -1),
    },
    {
      key: "city",
      title: intl.formatMessage({
        id: "address.city",
        defaultMessage: "Město",
      }),
      dataIndex: "city",
      sorter: (a, b) => (a.city ? a.city.localeCompare(b.city) : -1),
    },
    {
      key: "zipCode",
      title: intl.formatMessage({
        id: "address.zipCode",
        defaultMessage: "PSČ",
      }),
      dataIndex: "zipCode",
      sorter: (a, b) => (a.zipCode ? a.zipCode.localeCompare(b.zipCode) : -1),
    },
    {
      key: "country",
      title: intl.formatMessage({
        id: "address.country",
        defaultMessage: "Stát",
      }),
      dataIndex: "country",
      sorter: (a, b) => (a.country ? a.country.localeCompare(b.country) : -1),
    },
    {
      key: "contactPerson",
      title: intl.formatMessage({
        id: "address.contactPerson",
        defaultMessage: "Kontaktní osoba",
      }),
      dataIndex: "contactPerson",
      sorter: (a, b) =>
        a.contactPerson ? a.contactPerson.localeCompare(b.contactPerson) : -1,
    },
    {
      key: "contactPhone",
      title: intl.formatMessage({
        id: "address.contactPhone",
        defaultMessage: "Telefon",
      }),
      dataIndex: "contactPhone",
      sorter: (a, b) =>
        a.contactPhone ? a.contactPhone.localeCompare(b.contactPhone) : -1,
    },
    {
      key: "contactEmail",
      title: intl.formatMessage({
        id: "address.contactEmail",
        defaultMessage: "Email",
      }),
      dataIndex: "contactEmail",
      sorter: (a, b) =>
        a.contactEmail ? a.contactEmail.localeCompare(b.contactEmail) : -1,
    },
    {
      key: "delete",
      title: "",
      dataIndex: "",
      render: (a) => (
        <TableRowActions
          onEdit={() => handleEditAddress(a)}
          onDelete={() => dropAddress(a.key)}
        >
          <IconButton
            icon="plus"
            className="table-row-action-button"
            onClick={() => handleNewAddress(a)}
            title={intl.formatMessage({
              id: "customer.new",
              defaultMessage: "vytvořit nového zákazníka na základě tohoto",
            })}
          />
        </TableRowActions>
      ),
    },
  ];

  return (
    <LoadTable
      what={intl.formatMessage({
        id: "customer.genitivMultiple",
        defaultMessage: "zákazníků",
      })}
      columns={columns}
      values={addresses}
      onLoadValues={loadAddresses}
      selectedRows={selectedAddresses}
      emptyText={intl.formatMessage({
        id: "customer.noCustomers",
        defaultMessage: "žádní zadaní zákazníci",
      })}
      onRowDoubleClick={handleEditAddress}
      setSelectedRows={setSelectedAddresses}
    />
  );
}

export default connect(null, { push })(AddressListTable);
